import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  Select,
  MenuItem,
  Typography,
  SelectChangeEvent,
} from "@mui/material";
import { isEnglishString } from "../utils/validations";
import { PROPERTY_TYPE } from "../utils/enums";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  //   handleSubmit: () => void;
  error: boolean;

  setPropertyName: Dispatch<SetStateAction<string>>;
  propertyName: string;
  selectFieldUpdate: string;
  setSelectFieldUpdate: Dispatch<SetStateAction<string>>;
  setAddress: Dispatch<SetStateAction<string>>;
  address: string;
  setCity: Dispatch<SetStateAction<string>>;
  city: string;
  handleUpdateProperty: () => void;
}

export default function UpdateProperty({
  open,
  onClose,
  setOpen,
  error,
  address,
  city,
  propertyName,
  selectFieldUpdate,
  setAddress,
  setCity,
  setPropertyName,
  setSelectFieldUpdate,
  handleUpdateProperty,
}: AddCategoryModalProps) {
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectFieldUpdate(event.target.value as string);
  };

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Update Property</h2>
            <div className="btn-close" onClick={onClose}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <label>Property Name</label>
              <TextField
                placeholder="Enter Property Name"
                fullWidth
                hiddenLabel
                value={propertyName}
                onChange={(val) => {
                  if (isEnglishString(val.target.value)) {
                    setPropertyName(val.target.value);
                  }
                }}
              />
              {!propertyName && error ? (
                <h6 className="err_msg">This field is required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="control_group">
              <label>Category Name</label>
              <Select
                fullWidth
                labelId="country_to"
                id="country_to"
                value={selectFieldUpdate}
                onChange={handleChange1}
              >
                <MenuItem disabled value="default">
                  Select Property
                </MenuItem>
                <MenuItem value={PROPERTY_TYPE.HOME}>Home</MenuItem>
                <MenuItem value={PROPERTY_TYPE.VILLA}>Villa</MenuItem>
                <MenuItem value={PROPERTY_TYPE.APARTMENT}>Apartment</MenuItem>
                <MenuItem value={PROPERTY_TYPE.BUILDING}>Building</MenuItem>
              </Select>
              {selectFieldUpdate === "default" && error ? (
                <Typography
                  className="text_field"
                  style={{ color: "red", fontSize: "12px" }}
                >
                  This field is required
                </Typography>
              ) : null}
            </div>

            <div className="control_group">
              <label>Address</label>
              <TextField
                placeholder="Address"
                fullWidth
                hiddenLabel
                value={address}
                onChange={(val) => {
                  if (isEnglishString(val.target.value)) {
                    setAddress(val.target.value);
                  }
                }}
              />
              {!address && error ? (
                <h6 className="err_msg">This field is required</h6>
              ) : (
                ""
              )}
            </div>

            <div className="control_group">
              <label>Property Name</label>
              <TextField
                placeholder="Enter Property Name"
                fullWidth
                hiddenLabel
                value={city}
                onChange={(val) => {
                  if (isEnglishString(val.target.value)) {
                    setCity(val.target.value);
                  }
                }}
              />
              {!city && error ? (
                <h6 className="err_msg">This field is required</h6>
              ) : (
                ""
              )}
            </div>

            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={onClose}>
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={handleUpdateProperty}
              >
                Update
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
